/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-04-27 16:08:48
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-04-27 16:10:01
 * @FilePath: \crm-product\found\views\tpm\views\activity\three_months_data\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Page from '@/found/components/table_page';

export default {
  name: 'three_months_data',
  extends: Page,
  data() {
    return {
      params: {},
    };
  },
  components: {},
  created() {
    this.getConfigList('main_list');
  },
  methods: {},
};
